import React, { useRef } from "react";
import Tap_Payments from "../../images/brandLogos/Tap_Payments.webp";
import ShyftLogo from "../../images/brandLogos/ShyftLogo.webp";
import meydanLogo from "../../images/brandLogos/meydanLogo.webp";
import awsLogo from "../../images/brandLogos/awsLogo.webp";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";

function EcosystemPartnersSection() {
  const sectionRef = useRef(null);

  useGSAP(
    () => {
      gsap.fromTo(
        sectionRef.current,
        {
          opacity: 0,
          y: 100,
        },
        {
          scrollTrigger: {
            trigger: sectionRef.current,
            start: "top 80%",
            end: "top 75%",
            scrub: false,
            toggleActions: "play none none reverse",
          },
          opacity: 1,
          y: 0,
          duration: 1,
          ease: "sine.out",
        }
      );
    },
    {
      scope: sectionRef.current,
    }
  );

  return (
    <section
      ref={sectionRef}
      className="bg-white pb-[116px] flex flex-col items-center mt-32"
    >
      <h2 className="text-[35px] lg:text-3xl text-black font-HalvarBreitBold leading-[39px] lg:leading-[54px] -tracking-[2%] text-center lg:text-left">
        Our Ecosystem Partners
      </h2>

      <section className="flex flex-wrap lg:flex-nowrap items-center justify-center gap-y-[30px] gap-x-[22px] mt-11 lg:mt-4">
        <div className="flex items-center justify-center w-fit h-[60px] px-7 border-2 border-black bg-white rounded-[10px] shadow-[4px_4px_0_black]">
          <img
            src={Tap_Payments}
            alt="Tap Payments"
            className="w-[76px] object-contain"
            width={137}
            height={68}
            loading="lazy"
          />
        </div>
        <div className="flex items-center justify-center w-fit h-[60px] px-5 border-2 border-black bg-white rounded-[10px] shadow-[4px_4px_0_black]">
          <img
            src={ShyftLogo}
            alt="Shyft"
            className="w-[119px] object-contain"
            width={308}
            height={76}
            loading="lazy"
          />
        </div>
        <div className="flex items-center justify-center w-fit h-[60px] px-7 border-2 border-black bg-white rounded-[10px] shadow-[4px_4px_0_black]">
          <img
            src={meydanLogo}
            alt="Meydan"
            className="w-[104px] object-contain"
            width={219}
            height={89}
            loading="lazy"
          />
        </div>
        <div className="flex items-center justify-center w-fit h-[60px] px-7 border-2 border-black bg-white rounded-[10px] shadow-[4px_4px_0_black]">
          <img
            src={awsLogo}
            alt="AWS"
            className="w-[65px] object-contain"
            width={118}
            height={71}
            loading="lazy"
          />
        </div>
      </section>

      <button
        className="mt-16 lg:mt-20 text-lg font-gtAmericaMedium text-center uppercase leading-[21.69px] text-white bg-[#100C08] border border-black rounded w-fit pb-3 pt-3.5 px-20 "
        onClick={() => {
          window.open("https://forms.fillout.com/t/aeAxfJ1PBwus", "_blank");
        }}
      >
        PARTNER WITH US
      </button>
    </section>
  );
}

export default EcosystemPartnersSection;
